import { createStep } from "./scenario-manager";
import ListAppointment from "../components/appointment/ListAppointment";
import {
  addFieldData,
  nextStep,
  setReturnedValue,
  showDialogSms,
  userArea,
  stopLoading,
  toValidateToken,
  setMessageWithCode,
  setPayment,
  infoForStatusFormField
} from "../actions";
import {
  formatAppointment,
  formatNoAppointment,
  formatAppointmentList
} from "./formatter";
import {
  fetcher,
  getCodeSms,
  getReturnedValue,
  getSummaryReport,
  initValues
} from "./fetcher";
import { translator } from "./i18n";
import NoAvailableAppointment from "../components/appointment/NoAvailableAppointment";
import Calendar from "../components/appointment/Calendar";
import "url-search-params-polyfill";
import NoAppointment from "../components/appointment/NoAppointment";

export const processAppointments = (json, isAnest = false) => {
  const firstItem = Array.isArray(json) ? json[0] : json;
  const hasError = firstItem.code_error && firstItem.message_error;
  const displayAppointment = initValues().appointment;
  return hasError
    ? createStep({
        label: firstItem.message_error,
        component: {
          type: isAnest ? NoAppointment : NoAvailableAppointment
        },
        message: {
          message: firstItem.message_error,
          variant: "error"
        }
      })
    : createStep({
        label: translator()._("W_STEP3_TITRE_MENU_SELECTIONNEZ_VOTRE_RDV_AVEC"),
        label2: translator()._("W_STEP3_LIST_MENU_SELECTIONNEZ_VOTRE_RDV"),
        icon: "images/icone-professionnel.png",
        showLinkPriorityCode: true,
        component: {
          type: displayAppointment === "calendar" ? Calendar : ListAppointment
        },
        data: {
          fetchSource: () => addFieldData("appointment", json),
          formatSource:
            displayAppointment === "calendar"
              ? formatAppointment
              : formatAppointmentList,
          formatNoSource: formatNoAppointment,
          keyValue: "appointment"
        }
      });
};

export const callLbv = () => {
  return (dispatch, getState) => {
    fetcher()
      .get(getState().fetcher.urls.lbv)
      .then(response => response.json())
      .then(() => {
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const infoRdvToken = userId => {
  return (dispatch, getState) => {
    fetcher()
      .get(getState().fetcher.urls.infoRdvToken)
      .then(response => response.json())
      .then(json => {
        json = Array.isArray(json) ? json[0] : json;
        dispatch(setReturnedValue({ userId: userId, userInfo: json }));
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const getConsigns = (
  appointmentType,
  locationId,
  appointmentDate,
  practitionerId,
  beforeAppointment = false
) => {
  const requestParams = {
    idtyperdv: appointmentType,
    provenance: "web",
    idlieu: locationId,
    appointmentDate: appointmentDate,
    idpraticien: practitionerId,
    beforeAppointment: beforeAppointment,
    usePractitionerIdentifier: true
  };

  if (practitionerId !== 0) {
    requestParams["idpraticien"] = practitionerId;
  }

  return fetcher()
    .get("ajax/getAppointmentAlert.php", {
      searchParams: requestParams
    })
    .then(response => response.json())
    .then(json => {
      return json.success ? json.consigns : [];
    })
    .catch(error => {
      console.log(error.message);
      return [];
    });
};

export const saveAppointment = appointmentDetail => {
  return (dispatch, getState) => {
    const userId =
      getState().user.userData && getState().user.userData.userId
        ? getState().user.userData.userId
        : "";
    if (
      appointmentDetail.isRequiredPayment &&
      appointmentDetail.isRequiredPayment === "ok"
    ) {
      dispatch(setPayment({ isRequired: true }));
    }
    if (
      appointmentDetail.rdvpaiement &&
      appointmentDetail.rdvpaiement === "ok"
    ) {
      dispatch(setPayment({ isRequired: true }));
    }
    fetcher()
      .get("ajax/enregistrement_rdv.php", {
        searchParams: {
          select_rdv: getReturnedValue("appointment"),
          userId: userId,
          code_prioritaire: "",
          select_rdv_aide: getReturnedValue("rdvHelp")
        }
      })
      .then(response => response.json())
      .then(json => {
        json = Array.isArray(json) ? json[0] : json;
        dispatch(infoForStatusFormField(json));

        if (json.success === 1) {
          const byPass = json.bypass;
          if (json.identifiant_rdv) {
            dispatch(
              setReturnedValue({ appointmentIdentifier: json.identifiant_rdv })
            );
          }
          if (byPass === "avalider") {
            dispatch(toValidateToken(true));
            dispatch(infoRdvToken(json.id_user));
            dispatch(nextStep(getState().steps));
            dispatch(getCodeSms(json.id_user));
            dispatch(showDialogSms(true));
          } else if (byPass === "ok") {
            dispatch(callLbv());
            dispatch(userArea(true));
            dispatch(getSummaryReport(2));
          } else {
            dispatch(nextStep(getState().steps));
          }
        } else {
          dispatch(
            setMessageWithCode({ text: json.message_html, code: json.success })
          );
        }

        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};
